export default "__VITE_ASSET__00ca73f1__"